import { render } from "./MySwiper.vue?vue&type=template&id=6d0c6fe1&scoped=true"
import script from "./MySwiper.vue?vue&type=script&lang=js"
export * from "./MySwiper.vue?vue&type=script&lang=js"

import "./MySwiper.vue?vue&type=style&index=0&id=6d0c6fe1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0c6fe1"]])

export default __exports__